import theme, { HEADER_HEIGHT } from '@services/theme'

export default {
    root: {
        position: 'relative',
        top: HEADER_HEIGHT,
        width: '100%',
        backgroundColor: theme.palette.body.background
    }
}